(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uhp-promo-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uhp-product-carousel')) {
  customElements.define('uhp-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.uhp-promo__track');
      this.prev = this.querySelector('[data-promo-prev]');
      this.next = this.querySelector('[data-promo-next]');
      this.onScroll = () => this.update();
      this.prev.onclick = () => this.move(-1);
      this.next.onclick = () => this.move(1);
      this.track.addEventListener('scroll',this.onScroll,{passive:true});
      this.onKey = event => {
        if(event.target !== this.track) return;
        if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      };
      this.track.addEventListener('keydown',this.onKey);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.hidden = this.next.hidden = max < 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
    }
    move(direction) {
      const card = this.track.querySelector('.uhp-promo__card');
      if(!card)return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      const count = Math.max(1,Math.floor((this.track.clientWidth+1)/step));
      this.track.scrollBy({left:direction*step*count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.track?.removeEventListener('scroll',this.onScroll);
      this.track?.removeEventListener('keydown',this.onKey);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
